export default __webpack_public_path__ + "static/media/user-icon.1db92a4d.svg";